import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../../assets/jss/components/tableStyle";
import { useForm, Controller } from "react-hook-form";
import { validateBasicInfoForm } from "./BasicInfoValidators";
import { LOCALE } from "../../../properties/Locale";
import {
  TextField,
  Button,
  CircularProgress,
  Typography,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Grid,
  Icon,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
} from "@material-ui/core";
import { MunicipalitiesRepository } from "../../configuration/municipalities/MunicipalitiesRepository";
import { SchoolsRepository } from "../../configuration/schools/SchoolsRepository";
import { VacancyAppRepository } from "../VacancyAppRepository";
import { notifyShowErrorMessage } from "../../../common/actions/CommonActions";
import { UsersRepository } from "../../administration/users/UsersRepository";
import { Alert, AlertTitle } from "@material-ui/lab";
import { DropzoneArea, DropzoneDialog } from "material-ui-dropzone";
import { SETTINGS } from "../../../properties/ApiProps";
import FileIcon, { defaultStyles } from "react-file-icon";
import filesize from "filesize";
import { TrainingRepository } from "../vacancyProfessionalDevelopment/TrainingRepository";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { AuthService } from "../../../auth/AuthService";
import { ErrorMessageResolver } from "../../../common/components/ErrorMessageResolver";
import { tr } from "date-fns/locale";

const useStyles = makeStyles(styles);

export default function BasicInfo(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [btnSubmitLoading, setBtnSubmitLoading] = useState(false);
  const [municipalities, setMunicipalities] = useState();
  const [schools, setSchools] = useState();
  const [basicInfoData, setBasicInfoData] = useState({});
  const [rerender, triggerRerender] = React.useState(false);
  const [basicInfoFormErrors, setBasicInfoFormErrors] = useState();
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [currentUser, setCurrentUser] = useState(AuthService.getCurrentUser());
  const [attachments, setAttachments] = useState([]);
  const [files, setFiles] = useState([]);

  useEffect(() => {
    if (!municipalities) {
      MunicipalitiesRepository.fetchAllMunicipalities({
        page: 0,
        size: 100,
        orderBy: "name",
        orderDirection: "ASC",
      }).then((res) => {
        setMunicipalities(res.data);
        VacancyAppRepository.getBasicInfo(props.vacancyAppId).then((res) => {
          if (res.data) {
            setBasicInfoData(res.data);
            if (res.data.municipality != null) {
              SchoolsRepository.fetchAllSchoolsByMunicipality({
                municipalityId: res.data.municipality.id,
              }).then((res) => {
                setSchools(res.data);
                triggerRerender(!rerender);
              });
            }
            triggerRerender(!rerender);
          } else {
            UsersRepository.fetchCurrentUserDetails().then((res) => {
              let tmpBasicInfo = {
                firstName: res?.data?.teacher?.firstName,
                lastName: res?.data?.teacher?.lastName,
                birthDate: res?.data?.teacher?.birthDate,
                email: res?.data?.email,
                phoneNumber: "",
                municipality: res?.data?.teacher?.school?.municipality,
                school: res?.data?.teacher?.school,
              };
              if (res?.data?.teacher?.school?.municipality) {
                SchoolsRepository.fetchAllSchoolsByMunicipality({
                  municipalityId: res?.data?.teacher?.school?.municipality?.id,
                }).then((res) => {
                  setSchools(res.data);
                });
              }
              setBasicInfoData(tmpBasicInfo);
            });
          }
        });
      });
    }
  }, []);

  const handleSubmit = () => {
    let validationData = { ...basicInfoData };
    validationData.userType = currentUser.userType;
    var validFormData = validateBasicInfoForm.isValidSync(validationData);
    if (validFormData) {
      VacancyAppRepository.addBasicInfo(props.vacancyAppId, basicInfoData)
        .then((res) => {
          props.handleNextStep();
        })
        .catch((err) => {
          dispatch(notifyShowErrorMessage(ErrorMessageResolver.resolve(err)));
        });
    } else {
      var validationErrors = {};
      validateBasicInfoForm
        .validate(validationData, { abortEarly: false })
        .catch((err) => {
          err.inner.forEach((validationError) => {
            validationErrors[validationError.path] = {};
            validationErrors[validationError.path].message =
              validationError.message;
          });
          console.log(validationErrors);
          setBasicInfoFormErrors(validationErrors);
        });
    }
  };

  const setBasicInfoDataProp = (event, name) => {
    var data = basicInfoData;
    if (["municipality", "school"].includes(name)) {
      data[name] = {};
      data[name]["id"] = event.target.value;
    } else {
      data[name] = event.target.value;
    }
    setBasicInfoData(data);
    if (name === "municipality") {
      SchoolsRepository.fetchAllSchoolsByMunicipality({
        municipalityId: event.target.value,
      }).then((res) => {
        setSchools(res.data);
      });
    }
    triggerRerender(!rerender);
  };

  const handleChangeDate = (date, name) => {
    var data = basicInfoData;
    data[name] = date;
    setBasicInfoData(data);
    triggerRerender(!rerender);
  };

  const handleChangeFile = (files) => {
    setFiles(files);
    TrainingRepository.uploadFile(
      props.vacancyAppId,
      "BASIC_INFO",
      files[files.length - 1]
    ).then((res) => {
      let data = basicInfoData;
      if (!data.workingExperienceAttachment)
        data.workingExperienceAttachment = [];
      data.workingExperienceAttachment.push(res.data);
      setBasicInfoData(data);
    });
  };

  const deleteFile = (id, index) => {
    let data = basicInfoData;
    data.workingExperienceAttachment.splice(index, 1);
    setBasicInfoData(data);
    triggerRerender(!rerender);
  };

  return (
    <div
    // style={props.disabled ? { pointerEvents: "none", opacity: "0.8" } : {}}
    >
      <Grid container>
        <Grid item xs={12}>
          {!props.disabled && (
            <Alert
              style={{ marginBottom: "15px", marginTop: "10px" }}
              fullwidth="true"
              severity="info"
            >
              <AlertTitle>{LOCALE.basic_info}</AlertTitle>
              {LOCALE.basic_info_description}
            </Alert>
          )}
        </Grid>
        <Grid item xs={12}>
          {!props.disabled && (
            <Alert
              style={{ marginBottom: "35px", marginTop: "10px" }}
              fullwidth="true"
              severity="warning"
            >
              <AlertTitle>{LOCALE.choose_type_of_subjects}</AlertTitle>
              {LOCALE.choose_type_of_subjects_description}
            </Alert>
          )}
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={4}>
          <TextField
            id="firstName"
            label={LOCALE.name}
            fullWidth={true}
            margin="normal"
            InputLabelProps={{ shrink: true }}
            disabled={props.disabled}
            variant="outlined"
            size="small"
            name="firstName"
            onChange={(e) => setBasicInfoDataProp(e, "firstName")}
            value={basicInfoData?.firstName}
            error={basicInfoFormErrors?.firstName}
            helperText={basicInfoFormErrors?.firstName?.message}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            id="lastName"
            label={LOCALE.lastName}
            fullWidth={true}
            InputLabelProps={{ shrink: true }}
            disabled={props.disabled}
            margin="normal"
            variant="outlined"
            size="small"
            name="lastName"
            onChange={(e) => setBasicInfoDataProp(e, "lastName")}
            value={basicInfoData?.lastName}
            error={basicInfoFormErrors?.lastName}
            helperText={basicInfoFormErrors?.lastName?.message}
          />
        </Grid>
        <Grid item xs={4}>
          <FormControl
            fullWidth
            variant="outlined"
            disabled={props.disabled}
            size="small"
            margin="dense"
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                disableToolbar
                inputVariant="outlined"
                format="MM/dd/yyyy"
                margin="dense"
                id="date-from"
                disabled={props.disabled}
                onChange={(e) => handleChangeDate(e, "birthDate")}
                value={basicInfoData?.birthDate}
                label={LOCALE.dateOfBirth}
              />
            </MuiPickersUtilsProvider>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <TextField
            id="email"
            label={LOCALE.email}
            InputLabelProps={{ shrink: true }}
            disabled={props.disabled}
            fullWidth={true}
            margin="normal"
            variant="outlined"
            size="small"
            name="email"
            onChange={(e) => setBasicInfoDataProp(e, "email")}
            value={basicInfoData?.email}
            error={basicInfoFormErrors?.email}
            helperText={basicInfoFormErrors?.email?.message}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            id="phoneNumber"
            label={LOCALE.phoneNumber}
            fullWidth={true}
            disabled={props.disabled}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
            size="small"
            name="phoneNumber"
            onChange={(e) => setBasicInfoDataProp(e, "phoneNumber")}
            value={basicInfoData?.phoneNumber}
            error={basicInfoFormErrors?.phoneNumber}
            helperText={basicInfoFormErrors?.phoneNumber?.message}
          />
        </Grid>
      </Grid>

      <FormControl
        error={basicInfoFormErrors?.municipality}
        variant="outlined"
        fullWidth
        disabled={props.disabled}
        size="small"
        margin="normal"
      >
        <InputLabel>{LOCALE.municipality}</InputLabel>

        {municipalities && (
          <Select
            label={LOCALE.municipality}
            value={
              basicInfoData.municipality ? basicInfoData.municipality.id : ""
            }
            onChange={(e) => setBasicInfoDataProp(e, "municipality")}
          >
            {municipalities?.content.map((municipality) => (
              <MenuItem key={municipality.id} value={municipality.id}>
                {municipality.name}
              </MenuItem>
            ))}
          </Select>
        )}

        <FormHelperText id="municipality-helper-text">
          {basicInfoFormErrors?.municipality?.message}
        </FormHelperText>
      </FormControl>
      {schools && (
        <FormControl
          error={basicInfoFormErrors?.school}
          variant="outlined"
          fullWidth
          disabled={props.disabled}
          size="small"
          margin="normal"
        >
          <InputLabel>{LOCALE.school}</InputLabel>

          <Select
            label={LOCALE.school}
            value={basicInfoData.school?.id}
            onChange={(e) => setBasicInfoDataProp(e, "school")}
          >
            <MenuItem value={""}>None</MenuItem>
            {schools?.map((school) => (
              <MenuItem key={school.id} value={school.id}>
                {school.name}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText id="school-helper-text">
            {basicInfoFormErrors?.school?.message}
          </FormHelperText>
        </FormControl>
      )}

      <Grid container spacing={3}>
        {currentUser && currentUser.userType != "ASSOCIATE" && (
          <Grid item xs={6}>
            <FormControl
              error={basicInfoFormErrors?.subjectType}
              variant="outlined"
              fullWidth
              disabled={props.disabled}
              size="small"
              margin="normal"
            >
              <InputLabel>{LOCALE.subjects_type}</InputLabel>

              <Select
                label={LOCALE.subjects_type}
                value={
                  basicInfoData.subjectType ? basicInfoData.subjectType : ""
                }
                onChange={(e) => setBasicInfoDataProp(e, "subjectType")}
              >
                <MenuItem key="BASIC" value="BASIC">
                  {LOCALE.basic_subjects}
                </MenuItem>
                <MenuItem key="PROFESSIONAL" value="PROFESSIONAL">
                  {LOCALE.professional_subjects}
                </MenuItem>
              </Select>
              <FormHelperText id="school-helper-text">
                {basicInfoFormErrors?.subjectType?.message}
              </FormHelperText>
            </FormControl>
          </Grid>
        )}
        <Grid
          item
          xs={currentUser && currentUser.userType != "ASSOCIATE" ? 6 : 12}
        >
          <FormControl
            error={basicInfoFormErrors?.teachingLanguage}
            variant="outlined"
            fullWidth
            disabled={props.disabled}
            size="small"
            margin="normal"
          >
            <InputLabel>{LOCALE.teaching_languages}</InputLabel>

            <Select
              label={LOCALE.teaching_languages}
              value={
                basicInfoData.teachingLanguage
                  ? basicInfoData.teachingLanguage
                  : ""
              }
              onChange={(e) => setBasicInfoDataProp(e, "teachingLanguage")}
            >
              <MenuItem value="MACEDONIAN">{LOCALE.macedonian}</MenuItem>
              <MenuItem value="ALBANIAN">{LOCALE.albanian}</MenuItem>
              <MenuItem value="TURKISH">{LOCALE.turkish}</MenuItem>
            </Select>
            <FormHelperText id="school-helper-text">
              {basicInfoFormErrors?.teachingLanguage?.message}
            </FormHelperText>
          </FormControl>
        </Grid>
        {basicInfoData.subjectType === "PROFESSIONAL" && (
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              fullWidth
              size="small"
              label={LOCALE.professional_subjects}
              value={basicInfoData.professionalSubject || ""}
              onChange={(e) => setBasicInfoDataProp(e, "professionalSubject")}
              error={!!basicInfoFormErrors?.professionalSubject}
              helperText={basicInfoFormErrors?.professionalSubject?.message}
              disabled={props.disabled}
            />
          </Grid>
        )}
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          {" "}
          <TextField
            id="yearsWorkingExperience"
            label={LOCALE.years_working_experience}
            InputLabelProps={{ shrink: true }}
            fullWidth={true}
            margin="normal"
            disabled={props.disabled}
            type="number"
            variant="outlined"
            size="small"
            name="yearsWorkingExperience"
            onChange={(e) => setBasicInfoDataProp(e, "yearsWorkingExperience")}
            value={basicInfoData?.yearsWorkingExperience}
            error={basicInfoFormErrors?.yearsWorkingExperience}
            helperText={basicInfoFormErrors?.yearsWorkingExperience?.message}
          />
        </Grid>
        <Grid item xs={6}>
          <FormControl
            error={basicInfoFormErrors?.workingExperienceAttachment}
            variant="outlined"
            fullWidth
            disabled={props.disabled}
            size="small"
            margin="normal"
          >
            <Button
              variant="contained"
              color="primary"
              fullWidth={true}
              disabled={props.disabled}
              onClick={() => setOpenUploadDialog(true)}
            >
              <Icon>attach_file</Icon> &nbsp; {LOCALE.upload_file_piom}
            </Button>
            <FormHelperText id="school-helper-text">
              {basicInfoFormErrors?.workingExperienceAttachment?.message}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl
            error={basicInfoFormErrors?.workingExperienceAttachment}
            variant="outlined"
            fullWidth
            disabled={props.disabled}
            size="small"
            margin="normal"
          >
            <Button
              variant="contained"
              color="primary"
              fullWidth={true}
              disabled={props.disabled}
              onClick={() => setOpenUploadDialog(true)}
            >
              <Icon>attach_file</Icon> &nbsp;{" "}
              {"Решение/нија за распоредување на работно место"}
            </Button>
            <FormHelperText id="school-helper-text">
              {basicInfoFormErrors?.workingExperienceAttachment?.message}
            </FormHelperText>
          </FormControl>
          <FormControl
            error={basicInfoFormErrors?.workingExperienceAttachment}
            variant="outlined"
            fullWidth
            disabled={props.disabled}
            size="small"
            margin="normal"
          >
            <Button
              variant="contained"
              color="primary"
              fullWidth={true}
              disabled={props.disabled}
              onClick={() => setOpenUploadDialog(true)}
            >
              <Icon>attach_file</Icon> &nbsp;{" "}
              {"Диплома или уверение за завршено соодветно образование "}
            </Button>
            <FormHelperText id="school-helper-text">
              {basicInfoFormErrors?.workingExperienceAttachment?.message}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container xs={12}>
        <Grid item xs={12}>
          <DropzoneDialog
            multiple={false}
            onChange={(files) => handleChangeFile(files)}
            previewChipProps={false}
            showFileNamesInPreview={false}
            showPreviews={false}
            showPreviewsInDropzone={false}
            filesLimit={10}
            cancelButtonText={LOCALE.close}
            submitButtonText={LOCALE.save}
            dialogTitle={LOCALE.uploadFile}
            onSave={() => setOpenUploadDialog(false)}
            onClose={() => setOpenUploadDialog(false)}
            open={openUploadDialog}
            dropzoneText={LOCALE.dropzoneText}
            acceptedFiles={[".pdf", ".docx", ".xls", ".xlsx", ".rar", ".zip"]}
          ></DropzoneDialog>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>
                  <strong>{LOCALE.fileName}</strong>
                </TableCell>
                <TableCell style={{ width: "200px", textAlign: "center" }}>
                  <strong>{LOCALE.fileSize}</strong>
                </TableCell>
                <TableCell style={{ width: "200px", textAlign: "center" }}>
                  <strong>{LOCALE.actions}</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {basicInfoData &&
                basicInfoData.workingExperienceAttachment &&
                basicInfoData?.workingExperienceAttachment.map(
                  (attachment, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <FileIcon
                          size={50}
                          extension={attachment.fileExtension}
                          {...defaultStyles[attachment.fileExtension]}
                        />
                      </TableCell>
                      <TableCell>{attachment.filename}</TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {filesize(attachment.fileSize)}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        <a
                          target="blank"
                          href={`${SETTINGS.API_URL}vacancyApplications/${
                            props.vacancyAppId
                          }/attachments/${attachment.id}?access_token=${
                            AuthService.getToken().access_token
                          }`}
                        >
                          <IconButton
                            size="small"
                            color="secondary"
                            aria-label="Download"
                          >
                            <Icon>cloud_download</Icon>
                          </IconButton>
                        </a>
                        {!props.disabled && (
                          <IconButton
                            size="small"
                            color="secondary"
                            aria-label="delete"
                            onClick={() => deleteFile(attachment.id, index)}
                          >
                            <Icon>delete</Icon>
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  )
                )}{" "}
            </TableBody>
          </Table>
        </Grid>
      </Grid>

      {!props.disabled && (
        <Button
          style={{ float: "right" }}
          type="submit"
          size="small"
          variant="contained"
          disabled={btnSubmitLoading}
          onClick={() => handleSubmit()}
          className={btnSubmitLoading ? "btn-loading" : ""}
          color="secondary"
        >
          {LOCALE.next}
          {btnSubmitLoading && (
            <CircularProgress
              color="secondary"
              size={20}
              style={{ position: "absolute" }}
            />
          )}
        </Button>
      )}
    </div>
  );
}
